module.exports = __webpack_public_path__ + "static/media/Player1.c6553803.png";